module.exports = __webpack_public_path__ + "static/media/astrologer_dashboard_client.5d4fbec5.png";